'use strict';

const _=require('pulsar-utils/dist-es6/_');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ItemPickerDirective=require('../../../../dist-es6/client/directives/itemPickerDirective/itemPickerDirective');
const ItemPickerDirectiveController=ItemPickerDirective.DirectiveController;let

NotificationTypePickerDirective=class NotificationTypePickerDirective extends ItemPickerDirective{
get templateUrl(){return'/templates/directives/notificationTypePickerDirective/notificationTypePickerTemplate'}
get controller(){return NotificationTypePickerDirectiveController}
get objectBindings(){return super.objectBindings.concat(['fatigueThreshold','deviationThreshold'])}};let


NotificationTypePickerDirectiveController=class NotificationTypePickerDirectiveController extends ItemPickerDirectiveController{
static get $inject(){return['$scope','displaySettingsService']}

constructor($scope,displaySettingsService){
super($scope);

this._displaySettingsService=displaySettingsService;

this.items=NotificationType.All;
this.itemFormatter=type=>type.description;
this._reevaluateSelection=()=>this._reevaluateSelectionAndUpdateDisplaySettings();

const stickySetting=this._displaySettingsService.stickySettings.get('selectedNotificationType');
if(_.exists(stickySetting)){
this.selectedItem=stickySetting;
}

this._reevaluateSelection();
}

_reevaluateSelectionAndUpdateDisplaySettings(){
super._reevaluateSelection();
this._displaySettingsService.stickySettings.set('selectedNotificationType',this.selectedItem);
}};


module.exports=NotificationTypePickerDirective;
//# sourceMappingURL=notificationTypePickerDirective.js.map
